<template>
  <!--  <q-ajax-bar position="top" color="primary" />-->
  <router-view />
</template>

<script lang="ts" setup>
import { api } from '@/boot/axios'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

defineOptions({
  name: 'App',
})
const $router = useRouter()

onMounted(() => {
  void api.get('sanctum/csrf-cookie')
  void $router.isReady().then(() => {
    const splashContainer = document.getElementById('splash-container')
    if (splashContainer) {
      splashContainer.style.display = 'none'
    }
  })
})

/*useEcho('test', '.', (e) => {
  console.info(e)
})*/
</script>
